import { default as AreaPlot } from "./AreaPlot";
/**
    @class StackedArea
    @extends Area
    @desc Creates a stacked area plot based on an array of data.
    @example <caption>the equivalent of calling:</caption>
new d3plus.AreaPlot()
  .stacked(true)
*/

var StackedArea = function (AreaPlot) {
  function StackedArea() {
    AreaPlot.call(this);
    this._stacked = true;
  }

  if (AreaPlot) StackedArea.__proto__ = AreaPlot;
  StackedArea.prototype = Object.create(AreaPlot && AreaPlot.prototype);
  StackedArea.prototype.constructor = StackedArea;
  return StackedArea;
}(AreaPlot);

export default StackedArea;